<!-- steppercomponent.vue -->
<template>
  <div class="flex flex-col gap-0">
    <div
      v-if="isDeliveredView"
      class="flex flex-col gap-1 bg-green-50 border border-green-200 rounded-lg p-4"
    >
    <div class="flex items-center gap-2">
        <V3ImageComponent
          :src="deliveredItem.icon"
          class="w-6 h-6"
        />
        <p class="font-semibold text-md">Delivered</p>
      </div>
      <p class="text-sm text-gray-500">
        {{ deliveredItem.subtitle }}
      </p>
    </div>
    <div
      v-else-if="isCancelledView"
      class="flex flex-col gap-1 bg-[#FFE8E8] border border-[#E9E9E9] rounded-lg p-4"
    >
    <div class="flex items-center gap-2">
        <V3ImageComponent
          :src="cancelledItem.icon"
          class="w-6 h-6"
        />
        <p class="font-semibold text-md">Cancelled</p>
      </div>
      <p class="text-sm text-gray-500">
        {{ cancelledItem.subtitle }}
      </p>
    </div>
    <template v-else>
     <div class="bg-white p-4 rounded-lg shadow">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="relative flex gap-2 -mt-1"
      >
        <div
          class="flex flex-col items-center relative"
          :class="{ 'mb-12': index < items.length - 1 }"
        >
          <V3ImageComponent :src="item.icon" class="h-6 w-6" />

          <div
            v-if="index < items.length - 1"
            class="absolute left-1/2 top-full -translate-x-1/2"
            :style="{
              height: '50px',
              width: '2px',
              borderLeft: '2px dotted',
              borderColor: ['box.png', 'truck-time.png'].some(icon =>
                item.icon.includes(icon)
              )
                ? '#d1d5db'
                : '#22c55e'
            }"
          />
        </div>

        <div class="flex flex-col">
         <h5 class="text-md font-semibold text-black text-[14px] font-weight: 500">
          {{ item.title }}
        </h5>
        <p v-if="item.subtitle" class="text-sm text-gray-500 text-[12px]">
        </p>
          <!-- <p class="text-sm text-gray-500" v-if="item.subtitle">
          {{ item.subtitle }}
          </p> -->
          <p v-if="item.subtitle" class="text-sm text-gray-500">
            <template v-if="item.subtitle.startsWith('Expected delivery')">
              <span class="font-medium text-[12px] font-weight: 500">Expected delivery</span>
              <span class="font-regular text-[12px] font-weight: 400">{{ item.subtitle.replace('Expected delivery', '') }}</span>
            </template>
            <template v-else-if="item.subtitle.startsWith('On')">
              <span class="font-medium text-[12px] font-weight: 500 ">On</span>
              <span class="font-normal text-[12px] font-weight: 400 ">{{ item.subtitle.replace('On', '') }}</span>
            </template>
            <template v-else>
              <span class="font-normal text-gray-500 font-weight: 400">{{ item.subtitle }}</span>
            </template>
         </p>


        </div>
      </div>
      </div>
    </template>

    <!-- Note with refund icon -->
    <!-- <div
      v-if="note"
      class="flex items-center gap-2 mt-3 p-3 rounded-md bg-gray-100 text-sm text-gray-700 shadow-sm"
    >
      <img
        v-if="items.some(item => item.title && item.title.toLowerCase().includes('refund initiated'))"
        src="/v1/icons/refund.png"
        alt="Refund Icon"
        title="Refund Initiated"
        class="w-5 h-5 flex-shrink-0"
      />
      <p class="leading-snug text-left">
        {{ note }}
      </p>
    </div> -->
  </div>
</template>

<script setup>
const props = defineProps(['items'])
const note = ref('')

const deliveredItem = computed(() =>
  props.items.find(
    i => i.title === 'Delivered' && i.subtitle
  )
)

const cancelledItem = computed(() =>
  props.items.find(
    i => i.title === 'Cancelled' && i.subtitle
  ) 
)
const isDeliveredView = computed(() => !!deliveredItem.value)
const isCancelledView = computed(() => !!cancelledItem.value)

onMounted(() => {
  if (props.items.some(i => i.title.toLowerCase() === 'refund initiated')) {
    const refundItem = props.items.find(i => i.title.toLowerCase() === 'refund initiated');
    note.value = refundItem?.rrn 
      ? `Refund has been initiated. The RRN number is ${refundItem.rrn}. Amount will reflect in your account within 7-10 days.` 
      : `Refund has been initiated. Amount will reflect in your account within 7-10 days.`
  } else if (props.items.some(i => i.title.toLowerCase() === 'refund failed')) {
    note.value = 'Refund failed due to a technical issue. Refund will be reinitiated shortly.'
  }
})
</script>